// extracted by mini-css-extract-plugin
module.exports = {"Root":"general-layout_Root__ZOWsW","Main":"general-layout_Main__J0hl6"};